import convertPascalToCamelCase from "./convertPascalToCamelCase";

/**
 * Lowercases the first character of each dot-separated property-path segment.
 *
 * Postconditions: Falsy input returns undefined. Other characters, including bracket indices and
 * empty segments, retain their positions. No path parsing, validation or acronym conversion occurs.
 */
const convertPascalToCamelCasePropertyPath = (camelCaseStr: string | undefined) => {
    if (!camelCaseStr) {
        return undefined;
    }

    return camelCaseStr.split(".").map(convertPascalToCamelCase).join(".");
};

export default convertPascalToCamelCasePropertyPath;
